import { InlineErrorMessage, Label } from '@atoms/*';
import { FunctionComponent, ReactNode } from 'react';

interface DateAndTimeProps {
  labelText?: string;
  description?: ReactNode;
  children: ReactNode;
}

export const DateTemplate: FunctionComponent<DateAndTimeProps> = ({
  labelText,
  description,
  children,
}) => {
  return (
    <section className="flex flex-col gap-y-1">
      <Label
        className={`!text-brand text-bodyLg font-semibold`}
        htmlFor={labelText?.toLowerCase().replaceAll(' ', '-')}
        text={labelText}
        isTitle={false}
      />
      <p data-testid="description" className="text-dark-grey text-bodyLg">
        {description}
      </p>
      <section className="-mt-3 flex flex-col">{children}</section>
    </section>
  );
};
